import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  const navigate = useNavigate();

  const goToHome = () => {
    navigate('/');
  };

  return (
    <div className="not-found">
      <h1>404</h1>
      <p>Page Not Found</p>
      <button onClick={goToHome}>Go to Home</button>
    </div>
  );
};

export default NotFound;